import React, { useState } from "react";
import { Grid, Container } from "@mui/material";
import SideBarLinks from "../../shared/customers/sidebar/SideBarLinks";
import SideLinks from "../../shared/customers/sidebar/SideLinks";
import MyOrders from "./MyOrders";
import OrderQuotes from "./OrderQuotes";
import {
  TranLayoutWrapper,
  LayoutWrap,
  ContactMain,
} from "./styles/OrdersLayoutStyles";
import { useDispatch, useSelector } from "react-redux";
import { SetProfileMobileSidebar } from "../../../redux/slice/common/CommonSlice";

const OrdersLayout = () => {
  const [selectedLink, setSelectedLink] = useState(0);
  const dispatch = useDispatch();
  const GetSidebarState = useSelector(
    (state) => state.common.ProfileMobileSidebar
  );
  const links = [{ label: "Active Orders" }, { label: "Quotes" }];

  const handleLinkClick = (link) => {
    setSelectedLink(link);
    dispatch(SetProfileMobileSidebar(!GetSidebarState));
  };

  return (
    <>
      <TranLayoutWrapper>
        <Container maxWidth="lg">
          <LayoutWrap>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={1} md={4} lg={3}>
                <SideBarLinks>
                  <SideLinks
                    links={links}
                    selectedLink={selectedLink}
                    onLinkClick={handleLinkClick}
                  />
                </SideBarLinks>
              </Grid>
              <Grid item xs={12} sm={11} md={8} lg={9}>
                <ContactMain>
                  {selectedLink === 0 && <MyOrders />}
                  {selectedLink === 1 && <OrderQuotes />}
                </ContactMain>
              </Grid>
            </Grid>
          </LayoutWrap>
        </Container>
      </TranLayoutWrapper>
    </>
  );
};

export default OrdersLayout;
